var watchlistPositionAdd = {
	title: "Positie toevoegen",
	subtitle: "Volglijst: {value}",
	noSelectedPositions: "Momenteel zijn er geen posities geselecteerd om toe te voegen aan de volglijst.",
	singleSelectedPosition: "Er is 1 positie geselecteerd om toe te voegen aan de volglijst.",
	multipleSelectedPositions: "Er zijn {value} posities geselecteerd om toe te voegen aan de volglijst.",
	submit: "Ok",
	cancel: "Annuleren",
	remove: "Verwijderen",
	validationErrors: {
		positionExists: "Je selectie is al toegevoegd op je volglijst"
	},
	noWatchlists: {
		title: "Info",
		message: "Er is nog geen volglijst gemaakt."
	}
};
var nl = {
	watchlistPositionAdd: watchlistPositionAdd
};

export { nl as default, watchlistPositionAdd };
